import * as React from 'react'
import Typography from "../../components/Typography";

export default class WarningLabel extends React.Component{

    state : any = {

    }
    props : any = {
        message:undefined,
        show:false
    }

    constructor(props:any) {
        super(props);
        let state = this.state
        state.message = this.props.message
        state.show = this.props.show
        this.setState(state)
    }
    componentWillReceiveProps(props : any, nextContext : any) {
        let state = this.state
        state.message = props.message
        state.show = props.show
        this.setState(state)
    }

    render() {
        let message = this.props.message
        let show = this.state.show
        if(message && message!==''){
            return (
                <>
                    {
                        show&&(
                            <Typography type="blockquote" tag="h6" className="text-danger pt-2 pb-1" style={{...this.props.style}}>
                                <strong style={{fontSize:'13px', ...this.props.style}}>
                                    {
                                        this.state.message
                                    }
                                </strong>
                            </Typography>
                        )
                    }
                </>
            );
        }else{
            return (null)
        }
    }
}
